module.exports = __webpack_public_path__ + "img/empty-search.ba34a639.jpg";